var map = {
	"./clean-and-safe.png": 2860,
	"./eco-hospitality.webp": 6769,
	"./gastronomy.webp": 4517,
	"./human-wellbeing.webp": 8179,
	"./meetings.webp": 4431,
	"./recycling.webp": 5870,
	"./transfers.png": 2241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3805;